import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '~/app/core/components/confirm-dialog/confirm-dialog.component';
import { UxService, ValidationService } from '~/app/core/services';
import { ContractorsListBaseComponent } from '~/app/open-age/directory/components/contractors-list-base.component';
import { Contractor } from '~/app/open-age/directory/models';
import { ContractorService } from '~/app/open-age/directory/services/contractor.service';

@Component({
  selector: 'directory-contractors-list',
  templateUrl: './contractors-list.component.html',
  styleUrls: ['./contractors-list.component.css']
})
export class ContractorsListComponent extends ContractorsListBaseComponent implements OnInit {
  update: any;
  @Input()
  view: 'table' | 'list' | 'grid' = 'table';
  dialogRef: any;

  constructor(public dialog: MatDialog,
              public validationService: ValidationService,
              api: ContractorService,
              public uxService: UxService
  ) {
    super(api, uxService);
  }

  edit(Contractor: Contractor, isEdit: boolean) {
    if (isEdit) {
      Contractor.isEdit = true;
    } else {
      this.fetch();
      Contractor.isEdit = false;
    }
  }

  save(item) {
    item.isEdit = false;
    this.update(item);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  openDialog(item): void {
    this.uxService.onConfirm().subscribe(() => {
      this.remove(item);
      this.uxService.showInfo('Deleted');
    });
  }
}
